<template>
    <PopoverRight ref="popoverMenu" width="800px" >
        <div class="popover-slider-bar">
            <h1 class="bar-title">回答生成记录</h1>
            <p class="question">问题:{{question}}</p>
            <div class="cnt-area">
                <el-table
                    :data="recordList"
                    style="width: 100%"
                    :highlight-current-row="true"
                    stripe
                    tooltip-effect="dark"
                    ref="multipleTable"
                    header-cell-class-name="table-back"
                    class="list-table"
            >
                <el-table-column  label="回答" prop="answer_name"  align="center">
                    <template slot-scope="scope">
                        <div class="ellips2" :title="scope.row.answer_name">{{scope.row.answer_name}}</div>
                    </template>
                </el-table-column>
                <el-table-column  label="回答生成时间" prop="created_at"  align="center"></el-table-column>
               
            </el-table>
                <template v-if="recordList.length > 0">
                    <el-pagination
                        background
                        layout="total,prev, pager, next"
                        :current-page="condition.page"
                        :total="total"
                        :page-size="condition.per_page"
                        @current-change="currentChange"
                    ></el-pagination>
                </template>
            </div>
                
            <div class="form-button">
                 <el-button type="info" @click.stop.prevent="hide" >关闭</el-button>
            </div>
        </div>
    </PopoverRight>
</template>

<script>
    import {getTopicAnsRecord } from '@/service/topicBank'
    import PopoverRight from '@/components/popoverRight/index'
    export default {
        name: "record",
        components: {
            PopoverRight
        },
        data () {
         
            return {
               condition:{
                    record_detail_id:'',
                    per_page: 10,
                    page: 1,
               },
                total: 0,
                question:'',
                recordList:[],
            }
        },
        mounted(){
            
        },
        methods : {
            open (row) {
                this.condition.record_detail_id  = row.id;
                this.question = row.ask_name;
                this.$refs.popoverMenu && this.$refs.popoverMenu.open()
                this.getRecordDetail();
            },
            /** 关闭右侧悬浮层 */
            hide () {
                this.recordList=[];
                this.$refs.popoverMenu && this.$refs.popoverMenu.hide()
            },
            async getRecordDetail(){
                await getTopicAnsRecord(this.condition).then((data) => {
                    this.recordList = data.data;
                    this.total = data.total;
                })
            },
            currentChange(index) {
                this.condition.page = index;
                this.getRecordDetail();
            },
        },
    }
</script>

<style scoped>
    .cnt-area{
        margin-top:40px;
    }
    .list-table{
        border:1px solid #EBEEF5;
    }
   .question{
       margin-top:20px;
   }
   .popover-slider-bar .form-button{
       padding-left:40%;
   }
   .ellips2{
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        max-height:45px;
    }
</style>
